import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { setFullHeight } from '../../actions/uiActions';
import { clearTitleData } from '../../actions/titleActions';
import { loadPlaylistData } from '../../actions/playlistTitleActions';
import { RedirectAs404 } from '../Error404';
import Playlist from '../Playlist';


class PlaylistTitle extends Component {
  constructor (props) {
    super(props);
    this.state = {};
  }

  UNSAFE_componentWillMount () { // eslint-disable-line camelcase
    const { breakpoint, actions, uid, name, slug, shortDescription, longDescription, items } = this.props;
    actions.loadPlaylistData({ uid, name, slug, shortDescription, longDescription, items });
    actions.setFullHeight(breakpoint.greaterThanOrEqual.md);
  }

  UNSAFE_componentWillReceiveProps (nextProps) { // eslint-disable-line camelcase
    const { actions, breakpoint } = nextProps;
    if (breakpoint.mediaType !== this.props.breakpoint.mediaType) {
      actions.setFullHeight(breakpoint.greaterThanOrEqual.md);
    }
  }

  componentWillUnmount () {
    const { actions, uid } = this.props;
    actions.clearTitleData(uid);
  }

  render () {
    const { match, playlistData } = this.props;
    if (Object.keys(playlistData).length === 0) {
      // TODO: loading animation
      return null;
    }
    const { name, longDescription, itemUrls, defaultItemId } = playlistData;

    // return null;
    return (
      <Switch>
        <Route exact path={match.url} render={props => {
          const [urlSlug] = Object.entries(itemUrls).find(([slug, uid]) => uid === defaultItemId);
          return <Redirect to={`${match.url}/${urlSlug}`} />;
        }} />
        <Route exact path={`${match.url}/:urlSlug`} render={props => {
          const { urlSlug } = props.match.params;
          if (!itemUrls.hasOwnProperty(urlSlug)) {
            return <RedirectAs404 />;
          }
          const itemId = itemUrls[urlSlug];

          return (
            <div className="title-wrapper">
              <div className="title-alt-container">
                <header className="mb-4">
                  <h4 className="heading-alt text-uppercase mb-1">{name}</h4>
                  <div className="d-none d-sm-block body-copy muted" dangerouslySetInnerHTML={{ __html: longDescription }} />
                </header>
                <Playlist routeProps={props} activeItemId={itemId} {...playlistData} />
              </div>
            </div>
          );
        }} />
        <Route component={RedirectAs404} />
      </Switch>
    );
  }
}

PlaylistTitle.propTypes = {
  uid: PropTypes.string.isRequired,
  playlistData: PropTypes.object,
};

PlaylistTitle.defaultProps = {
  playlistData: {},
};

const mapStateToProps = ({ breakpoint, titles }, ownProps) => ({
  breakpoint,
  playlistData: titles[ownProps.uid],
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ setFullHeight, clearTitleData, loadPlaylistData }, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PlaylistTitle));



// WEBPACK FOOTER //
// ./src/components/Title/PlaylistTitle.js